import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Feed, Image } from 'semantic-ui-react';

const influencerAvatarStyle = {
  width: 50,
  height: 50,
  marginRight: 20,
  float: 'left',
};

const descriptionStyle = {
  color: 'gray',
};

const titleStyle = {
  marginTop: 5,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 171,
  overflow: 'hidden',
};

const feedEventStyle = { marginBottom: 20 };

export const FeedLeftImage = props => (
  <Image
    className="circular"
    style={influencerAvatarStyle}
    size="tiny"
    {...props}
  />
);

export const FeedTitleAndDescription = ({
  title,
  description,
}) => (
  <div>
    <div style={titleStyle}>
      { title }
    </div>
    <span style={descriptionStyle}>{description}</span>
  </div>
);

FeedTitleAndDescription.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const FeedEvent = ({
  createdBy,
  createdDate,
  actionText,
  children,
  isCompact,
}) => (
  <Feed.Event style={feedEventStyle}>
    <Feed.Content>
      <Feed.Summary>
        <Feed.User>{ createdBy }</Feed.User> { actionText }
        {
          !isCompact &&
          <Feed.Date>{ moment(createdDate).fromNow() }</Feed.Date>
        }
      </Feed.Summary>
      <Feed.Extra>
        { children }
      </Feed.Extra>
    </Feed.Content>
  </Feed.Event>
);

FeedEvent.propTypes = {
  createdBy: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  createdDate: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isCompact: PropTypes.bool,
};

FeedEvent.defaultProps = {
  isCompact: true,
};


export default FeedEvent;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/card-events/feed-event.js
 **/